<template>
    <div class="p-day-one__salary-finder">
        <p>Choose a salary:</p>
        <button class="a-button u-no-margin ashe" @click="selectSalary(null)">
            Use ASHE average for {{gender == "male" ? 'men' : 'women' }}
        </button>
        <button class="a-button u-no-margin refine" @click="openDialog">
            Refine by occupation
        </button>
        <modal name="ons_salary" no-default-button="true">
            <div class="p-day-one__refine-occupation">
                <h2>Refine by occupation</h2>

                <div v-if="selectedNode">
                    <p>
                        Your current selection - <strong>{{ getLastNode().description }}</strong><br/>
                        <span v-if="getLastNode().code.length !== 3">Select a salary, expand down further or use the average salary for this whole group</span>
                        <span v-else>Select a salary or use the average salary for this whole group</span>
                    </p>

                    <button @click="unselectNode(selectedNode)" class="a-button a-button--small">Back</button>
                    <button @click="selectSalary(selectedNode)" class="a-button a-button--small">Use average {{displaySalary(selectedNode)}}</button>
                </div>
                <div v-else>
                    <p>
                        Select a salary or expand the group
                    </p>
                </div>
                <div>
                    <div>
                        <table class=" a-table__small a-table a-table--full-width">
                            <thead>
                            <tr>
                                <th>Code</th>
                                <th>Description</th>
                                <th>Salary</th>
                                <th width="30"></th>
                                <th width="30"></th>
                            </tr>
                            </thead>
                            <tbody v-if="loading">
                            <td colspan="5" style="text-align: center;"><div class="a-loader--table"></div></td>
                            </tbody>
                            <tbody v-else>
                            <tr v-for="node in nodes" class="selected--row">
                                <td>{{node.code}}</td>
                                <td>{{node.description}}</td>
                                <td>{{displaySalary(node)}}</td>
                                <td>
                                    <button :disabled="node.code.length === 4" class="a-button a-button--small" @click.stop="selectNode(node)">
                                        Expand
                                    </button>
                                </td>
                                <td>
                                    <button v-if="node.salary!=='x'" class="a-button a-button--small" @click.stop="selectSalary(node, type)">
                                        Select
                                    </button>
                                </td>
                            </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </modal>
    </div>
</template>

<script>
    import Api from 'services/Api';
    import {mapGetters, mapActions} from 'vuex';
    import Modal from 'components/modal/Modal';
    import CurrencyFormat from 'mixins/currencyFormat';

    export default {
        name: 'salary-finder',
        components: {
            Modal
        },
        mixins: [
            CurrencyFormat
        ],
        props: {
            gender: {
                type: String,
                default: 'male'
            }
        },
        data() {
            return {
                loading: false,
                nodes: [],
                selectedNode: null,
                selectedNodes: []
            }
        },
        computed: {
            ...mapGetters('modal', ['modals']),
            isModalOpen() {
                return this.modals && this.modals.ons_salary;
            }
        },
        methods: {
            ...mapActions('modal', ['toggle']),
            openDialog() {
                if (!this.isModalOpen) {
                    this.nodes = [];
                    this.selectedNode = null;
                    this.selectedNodes = [];
                    return this.toggle('ons_salary').then(this.updateNodes);
                }
            },
            closeModal() {
                if (this.isModalOpen) {
                    return this.toggle('ons_salary');
                }
            },
            updateNodes(code = null) {
                this.loading = true;
                Api.calculators.ons.salary(this.gender, code)
                    .then(nodes => {
                        this.nodes = nodes;
                        this.loading = false;
                    });
            },
            selectNode(node) {
                if (node.code.length === 4) {
                    return;
                }
                this.selectedNode = node;
                this.selectedNodes.push(node);
                return this.updateNodes(node.code);
            },
            unselectNode(node) {
                let index = this.selectedNodes.indexOf(node);
                if (index === 0) {
                    this.selectedNodes = [];
                    this.selectedNode = null;
                    return this.updateNodes();
                }
                this.selectedNodes.splice(index);
                let lastIndex = this.selectedNodes.length - 1;
                this.selectedNode = this.selectedNodes[lastIndex];
                this.updateNodes(this.selectedNode.code);
            },
            selectSalary(node) {
                if (node === null) {
                    this.loading = true;
                    return Api.calculators.ons.averageSalary(this.gender)
                        .then(result => {
                            this.$emit('update', {
                                occupation: {
                                    description: 'National Average',
                                    code: 'XXX'
                                },
                                salary: result.value
                            });
                        })
                        .then(this.closeModal);
                }
                this.$emit('update', {
                    occupation: {
                        description: node.description,
                        code: node.code
                    },
                    salary: node.salary
                });
                this.closeModal();
            },
            displaySalary(node) {
                if (node.salary === "x") {
                    return "No Information";
                }
                return this.currencyFormat(node.salary, '£', 0);
            },
            getLastNode() {
                return this.selectedNodes.slice(-1)[0];
            }
        }
    }
</script>


// WEBPACK FOOTER //
// SalaryFinder.vue?11c639a8